import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenInNew = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M204-129q-30.938 0-52.969-22.031Q129-173.062 129-204v-552q0-30.938 22.031-52.969Q173.062-831 204-831h235.5q15.5 0 26.5 11t11 26.5q0 15.5-11 26.5t-26.5 11H204v552h552v-235.5q0-15.5 11-26.5t26.5-11q15.5 0 26.5 11t11 26.5V-204q0 30.938-22.031 52.969Q786.938-129 756-129H204Zm552-574.5L415.5-363q-10.5 10.5-25.75 10.5t-26.25-11q-11-11-11-26.25t10.876-26.126L703.5-756h-114q-15.5 0-26.5-11t-11-26.5q0-15.5 11-26.5t26.5-11h204q15.5 0 26.5 11t11 26.5v204q0 15.5-11 26.5t-26.5 11q-15.5 0-26.5-11t-11-26.5v-114Z" })
});
export default SvgOpenInNew;
